"use client"
import SEO from "../../../data/seo";
import HeaderFour from "../../../layout/headers/header-four";
import BannerFour from "./banner";
import AboutFour from "./about";
import ServicesFour from "./services";
import Advices from "./advices";
import PortfolioFour from "./portfolio";
import Industry from "./industry";
import TextSlide from "./text-slide";
// import BlogFour from "./blog";
import FooterFour from "../../../layout/footers/footer-four";

import PortfolioThree from "./portfolio-three";
import ServicesThree from "./services-three";
import ProcessThree from "./process-three";
import ServicesOne from "./services-one"
import VideoOne from "./video-one";
import ChooseUsOne from "./choose-us-one";
import PortfolioSecond from "./portfolio-second";
import FaqSecond from "./faq-second";
// import PortfolioOne from "./portfolio-one";

const HomeFour = () => {
    return (
        <>
            <SEO pageTitle="Ayyıldız İnşaat" />
            <HeaderFour />
            <BannerFour />
            <AboutFour />
            <ServicesFour />
            <Advices />
            <PortfolioFour />
            <Industry />
            <TextSlide />
            {/* <BlogFour /> */}
            <PortfolioThree />
            <ServicesThree />
            <ProcessThree />
            <ServicesOne />
            <VideoOne />
            <PortfolioSecond />
            <FaqSecond />
            {/* <PortfolioOne /> */}
            <FooterFour />
        </>
    );
};

export default HomeFour;
